import "@ms-mwf/moray/dist/css/themes/main-xbox.css";
import "./App.css";
import "./XdsStyling.module.scss";

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

import { FeatureGate, getBooleanFeatureGateEnabled } from "@gamedev-web/gamedev-sdk-core";
import { Theme, UserColors, XDSContext } from "@gaming/xds-foundation";
import { loadTheme, XdsTheme, xdsThemeToDataTheme } from "@gaming/xds-react-js";

import { ErrorBoundary } from "./components/ErrorBoundary";
import { RootState } from "./redux/reducers";
import { Shell } from "./shell";

const App = () => {
  const [platform, setPlatform] = useState("");
  const enableCookieSourceDebugConsole = useSelector(state =>
    getBooleanFeatureGateEnabled(state as RootState, FeatureGate.EnableCookieSourceDebugConsole)
  );
  const xdsTheme = XdsTheme.DefaultDark;

  useEffect(() => {
    loadTheme(xdsTheme);
  }, [xdsTheme]);

  useEffect(() => {
    setPlatform(navigator.platform);
  }, []);

  return (
    <ErrorBoundary>
      {() => (
        <div className="appBackground">
          <XDSContext.Provider
            value={{
              theme: Theme.Dark,
              platformType: "desktop",
              userColors: UserColors.XboxGreen,
            }}
          >
            <Helmet defaultTitle="XBOX Developer">
              {/* eslint-disable-next-line jsx-a11y/html-has-lang */}
              <html data-platform={platform} />
              {enableCookieSourceDebugConsole && (
                <script>
                  {`origDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
                    Object.defineProperty(document, 'cookie', {
                      get() {
                        return origDescriptor.get.call(this);
                      },
                      set(value) {
                        let obj = {};
                        try { Error.captureStackTrace(obj, value); }
                        catch(e) { obj = e; } // this is needed to make it work in FF
                        console.log("Cookie: ", value);
                        console.log("Cookie Stack: ", obj.stack);
                        return origDescriptor.set.call(this, value);
                      },
                      enumerable: true,
                      configurable: true
                    });`}
                </script>
              )}
              <body data-theme={xdsThemeToDataTheme(xdsTheme)} />
            </Helmet>
            <Shell />
          </XDSContext.Provider>
        </div>
      )}
    </ErrorBoundary>
  );
};

export default App;
